// extracted by mini-css-extract-plugin
export default {"tableHeader":"CustomTable_tableHeader__ij9s4","tableCell":"CustomTable_tableCell__46UKg","customTable":"CustomTable_customTable__S0qLC"};